import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';

/**
 * Opens PDF files in a new browser tab for preview.
 * All other file types are downloaded directly.
 */
export const downloadFileByLink = (name: string, link: string): void => {
  if (name.toLowerCase().endsWith('.pdf')) {
    window.open(link, '_blank');
  } else {
    downloadByUrl(link);
  }
};
